import React from 'react';
import '../AlgorithmView/AlgorithmList.css';


export default function AlgorithmList() {
  return (
    <aside >
    <div className='list-container'>
          {/* <div className='algo-desc'>
            <h1 className='algo-title'> 3-Coloring Graph </h1> 
            <p>Color the nodes of a graph with 3 colors such that no two adjacent nodes have the same color.</p>
            <p>
            Step-by-Step Visualization:<br/>
              1. Input number of nodes and edge connections <br/>   
              2. Initialize Graph <br/>
              3. Start Visualization <br/>
              4. Use 'Previous' and 'Next' buttons <br/>
            </p>

            <p>
              Complete Graph Visualization:<br/>
              1. Initialize Graph or Reset <br/>
              2. Visualize Execution
            </p>
        </div> */}

        <h1 className='title'>Related Algorithms</h1>
        <div className='container_l'>
            <li><a href='www.test' className='text-orange-500'>K-Coloring Graph</a></li>
            <li><a href='www.test' className='text-orange-500'>Travelling Salesman Problem</a></li>
           
        </div>
        
    </div>
    </aside>
  )
}
